const routes = {
  exemptionList: (): string => `contracts`,
};

export default routes;
